import { render, staticRenderFns } from "./incomeChart.vue?vue&type=template&id=1885cde2&scoped=true"
import script from "./incomeChart.vue?vue&type=script&lang=js"
export * from "./incomeChart.vue?vue&type=script&lang=js"
import style0 from "./incomeChart.vue?vue&type=style&index=0&id=1885cde2&prod&scoped=true&lang=scss"
import style1 from "./incomeChart.vue?vue&type=style&index=1&id=1885cde2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1885cde2",
  null
  
)

export default component.exports